export function getDocumentTypeId(value) {
  switch (value) {
    case 'accept':
      return 1
    case 'shipment':
      return 2
    case 'completeSet':
      return 4
    case 'writeOff':
      return 5
    case 'returns':
      return 6
    case 'change':
      return 7
    default:
      return null
  }
}

export function modifySortProperty(property) {
  switch (property) {
    case 'from':
    case 'fromWarehouse':
    case 'to':
    case 'toWarehouse':
    case 'parent':
    case 'city':
    case 'type':
    case 'operationType':
      return `${property}.name`
    default:
      return property
  }
}
